import { createContext } from "react";

export default createContext<string | null>(null);
